// Customers getters
export default {
  get_invoice_item_list: (state) => state.items,
  get_invoice_item_count: (state) => state.count
};
